export enum Platform {
    IOS = "ios",
    ANDROID = "an",
    DWEB = "dweb",
    MWEB = "mweb",
    WEB = "web",
}

// cleanup: remove this after the builds are fixed
export const DUMMY_TEXTS_TO_BE_REPLACED = "dummy";
